import { useQuery } from '@tanstack/react-query';

import { PluginEquifaxIdMatrixFormResponse } from '../../../../types/plugins';
import { handleError } from '../../../../utils/admin';
import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { unwrapNonPaginatedResponseDataAs } from '../../../logic/unwrapNonPaginatedResponseDataAs';
import { NonPaginatedResponse } from '../../../types/NonPaginatedResponse';
import { PLUGIN_BASE_PATH } from '../../constants/pluginBasePath';
import { runEquifaxIdMatrixForm } from '../../requests/runEquifaxIdMatrixForm';

export const useEquifaxIdMatrixForm = (
  applicationUuid: string,
  options?: { enabled?: boolean },
) => {
  const { constructPost } = useRequestConstructor();
  const { data, ...rest } = useQuery<
    NonPaginatedResponse<PluginEquifaxIdMatrixFormResponse> | undefined
  >({
    queryKey: [PLUGIN_BASE_PATH, 'equifax-id-matrix-form', applicationUuid],
    queryFn: () =>
      runEquifaxIdMatrixForm(constructPost, {
        params: { uuid: applicationUuid },
      }),
    enabled: !!applicationUuid,
    onError: () => handleError('There was a problem loading the options.'),
    ...options,
  });
  return { ...unwrapNonPaginatedResponseDataAs(data, 'formData'), ...rest };
};
